import fetch from 'isomorphic-unfetch';

const list = async (baseUrl, opts, controller = undefined) => {
  const result = await fetch(`${baseUrl}/api/payment_methods`, {
    method: 'GET',
    headers: {
      ...opts.headers,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    signal: controller ? controller.signal : undefined
  });
  return await result.json();
};

const create = async (token, controller = undefined) => {
  const result = await fetch('/api/payment_methods', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ token }),
    signal: controller ? controller.signal : undefined
  });
  return await result.json();
};

const remove = async (id, controller = undefined) => {
  const result = await fetch('/api/payment_methods', {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id }),
    signal: controller ? controller.signal : undefined
  });
  return await result;
};

const setupPayment = async (id, email, controller = undefined) => {
  const result = await fetch('/api/payment_methods/setup', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email: email, subscriptionId: id }),
    signal: controller ? controller.signal : undefined
  });
  return await result.json();
};

const paymentMethods = {
  list,
  create,
  remove,
  setupPayment: setupPayment
};
export default paymentMethods;
